/*
  Get the current region from the URL

  Supports:
    dev-web-cn.ffau.to
    faradayfuturecn.com
    localhost:xxxx/cn/
    dev-genesis.ffau.to/cn
    genesis.ff.com/cn

  ffai.com is never CN: www.ffai.com/cn/ is ffai.com's Chinese section, not the
  China site, so it keeps the US analytics (GTM dataLayer, not Baidu).
*/

const isFfaiUrl = url => /^https?:\/\/([a-z0-9-]+\.)*ffai\.com(:\d+)?(\/|$)/i.test(url || '');

const getRegion = url => (
  !isFfaiUrl(url) && /(-cn.ffau.to|faradayfuturecn.com|(:[\d]{4,5}|.to|.com)\/cn)/.test(url) ? 'CN' : 'US'
);

export default getRegion;
